import { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft, Printer, Award } from "lucide-react";
import { social } from "../lib/api";
import LoadingOverlay from "../components/LoadingOverlay";
import RankCertificate from "../components/social/RankCertificate";

export default function RankCertificatePage() {
  const { userId } = useParams();
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    setLoading(true);
    setError(null);
    social
      .getUserProfile(userId)
      .then(setProfile)
      .catch(() => setError("User not found."))
      .finally(() => setLoading(false));
  }, [userId]);

  if (loading) return <LoadingOverlay />;

  if (error) {
    return (
      <div className="text-center py-16">
        <p className="text-walnut-light">{error}</p>
        <Link
          to="/"
          className="inline-flex items-center gap-1.5 mt-4 text-sm font-medium text-terracotta hover:text-terracotta-dark transition-colors"
        >
          <ArrowLeft size={16} />
          Go Home
        </Link>
      </div>
    );
  }

  const hasRank =
    profile.rank && profile.rank !== "none" && profile.rank_history?.length > 0;

  if (!hasRank) {
    return (
      <div className="text-center py-16">
        <Award size={48} className="text-stone mx-auto mb-4" />
        <h2 className="font-display text-xl font-semibold text-walnut mb-2">
          No Rank Certificate Yet
        </h2>
        <p className="text-sm text-walnut-light mb-6 max-w-xs mx-auto">
          Earn community points to reach Bronze rank and unlock your certificate.
        </p>
        <Link
          to={`/users/${userId}`}
          className="inline-flex items-center gap-1.5 text-sm font-medium text-terracotta hover:text-terracotta-dark transition-colors"
        >
          <ArrowLeft size={16} />
          Back to Profile
        </Link>
      </div>
    );
  }

  return (
    <div>
      {/* Controls — hidden when printing */}
      <div className="print:hidden flex items-center justify-between mb-6">
        <Link
          to={`/users/${userId}`}
          className="inline-flex items-center gap-1.5 text-sm font-medium text-walnut-light hover:text-walnut transition-colors"
        >
          <ArrowLeft size={16} />
          Back to Profile
        </Link>
        <button
          onClick={() => window.print()}
          className="inline-flex items-center gap-1.5 px-4 py-2 rounded-md text-sm font-medium bg-terracotta text-white hover:bg-terracotta-dark transition-colors"
        >
          <Printer size={16} />
          Download PDF
        </button>
      </div>

      <RankCertificate profile={profile} />
    </div>
  );
}
